// extracted by mini-css-extract-plugin
export default {"tableContainer":"payments_tableContainer__vk5yV","topButtonsContainer":"payments_topButtonsContainer__bswpF"};